module.exports = __webpack_public_path__ + "img/SooKlein.9403b746.svg";